import PbjDownload from './pbj';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { reportsDownloadPBJ } from 'src/config';

/**
 * RA-2027 — cards for the *Labor* section of Report Downloads.
 *
 * Deliberately separate from `useDownloadData()` rather than an extra entry inside it. That hook
 * feeds the four live Billing & Month-End cards every customer already uses, and reshaping it to
 * carry a section per entry would put those four at risk for no gain. A second hook of the same
 * shape costs one extra call in `SlmReports`.
 *
 * Unlike `useDownloadData()`, disabled cards are filtered *out* instead of being left as empty
 * objects. The Labor heading only renders when this array is non-empty, so an empty placeholder
 * would produce exactly the regression the flag exists to prevent: a bare "Labor" heading over
 * nothing for every customer without the treatment.
 */
function useLaborDownloadData() {
  //  `useFeatureToggleWhenReady` returns null until the Split client is ready, which is falsy —
  //  so the section stays absent while the treatment is still resolving rather than flashing in.
  const [isPBJEnabled] = useFeatureToggleWhenReady(reportsDownloadPBJ, 'ENTERPRISE');

  const laborDownloadData = [
    ...(isPBJEnabled
      ? [
          {
            title: 'Payroll-Based Journal (PBJ) Export',
            description: {
              Includes:
                'Quarterly CMS staffing hours for the facility selected at the top of the page, by federal fiscal quarter.',
            },
            children: <PbjDownload />,
          },
        ]
      : []),
  ];

  return {
    laborDownloadData,
  };
}

export default useLaborDownloadData;
